const styles = (theme) => ({
    gallery: {
        display: 'flex',
        justifyContent: 'center'
    },
    gridContainer:{
        // width: '80%',
    },
    gridItem:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
    },
    gridImage: {
        objectFit: 'contain',
        // maxWidth: '100%',
        // maxHeight: '100%'
        width: '90%',
        height: '90%',
    }
});

export default styles;
